import { combineReducers } from 'redux';
import { createReducer } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    CUSTOMER_PROFILE_UPDATE_STARTED,
    CUSTOMER_PROFILE_UPDATE_SUCCEEDED,
    CUSTOMER_PROFILE_UPDATE_FAILED,
    CUSTOMER_PROFILE_INIT_STARTED,
    CUSTOMER_PROFILE_INIT_FAILED,
    CUSTOMER_PROFILE_INIT_SUCCEEDED,
} from '../actionTypes';

const update = createReducer(META_STATE_SUCCEEDED, {
    ...createEntityAsyncMetaHandlers({
        STARTED: CUSTOMER_PROFILE_UPDATE_STARTED,
        SUCCEEDED: CUSTOMER_PROFILE_UPDATE_SUCCEEDED,
        FAILED: CUSTOMER_PROFILE_UPDATE_FAILED,
    }),
});

const init = createReducer(META_STATE_SUCCEEDED, {
    ...createEntityAsyncMetaHandlers({
        STARTED: CUSTOMER_PROFILE_INIT_STARTED,
        SUCCEEDED: CUSTOMER_PROFILE_INIT_SUCCEEDED,
        FAILED: CUSTOMER_PROFILE_INIT_FAILED,
    }),
});

const reducer = combineReducers({
    update,
    init,
});

export default reducer;
